<template>
  <div class='page-wrap' :class='device=="mobile"?"mobile":""'>
    <nav-bar></nav-bar>
    <div class="app-container" v-loading='pageLoading'>
      <div class='theader'>
        <p>资产信息</p>
      </div>
      <div v-if='info' class="page-sec flex">
        <template>
          <el-image
            v-if='info.coverPicUrlBase64'
            class='col-image' style = "display: none"
            :src="'data:image/jpeg;base64,' + info.coverPicUrlBase64"
            fit="contain"></el-image>
          <div class='content-sec'>
            <div class="common-row"><span class='key'>主资产编号：</span><span class='value'>{{ info.mainId }}</span><span class="copy-btn" :data-clipboard-text="info.mainId" @click='copyFn'></span></div>
            <div class="common-row"><span class='key'>作品名称：</span><span class='value'>{{ info.productName }}</span></div>
            <div class="common-row"><span class='key'>作者名称：</span>
              <span class='value'>
                <el-tag
                  v-for="item in info.authorNames"
                  :key="item"
                  type="info"
                  effect="dark"
                  style='margin-right: 5px;'>
                  {{ item }}
                </el-tag></span>
            </div>
            <div class="common-row"><span class='key'>著作权人名称：</span><span class='value'>{{ info.ownerName }}</span></div>
            <div class="common-row"><span class='key'>发行时间：</span><span class='value'>{{ info.releaseTime }}</span></div>
            <div class="common-row"><span class='key'>发行份额：</span><span class='value'>{{ info.amount }}</span></div>
            <div class="common-row"><span class='key'>流通总量：</span><span class='value'>{{ info.totalCirculation }}</span></div>
            <div class="common-row"><span class='key'>发行状态：</span><span class='value text-green'>{{ info.releaseState===0?"等待发行":info.releaseState===1?"发行成功":"发行失败" }}</span></div>
            <div class="common-row"><span class='key'>发行账户：</span><span class='value link-type' @click='transAddr(info.userAddr)'>{{ info.userAddr }}</span><span class="copy-btn" :data-clipboard-text="info.userAddr" @click='copyFn'></span></div>
          </div>
        </template>
      </div>
      <div v-else class="page-sec">
        <el-row type='flex' justify="center" style='width: 100%;'>
          <el-empty :image-size="100" description="暂未找到您所查询的内容，请重新查询"></el-empty>
        </el-row>
      </div>

      <div class='theader'>
        <p>交易信息</p>
      </div>
      <template v-if='list && list.length>0'>
        <el-table
          ref='table'
          :key="tableKey"
          v-loading="listLoading"
          :data="list"
          fit
          highlight-current-row
          :size='device=="mobile"?"mini":""'
          style="width: 100%;"
        >
          <!-- <el-table-column label="ID" align="center" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="交易哈希" align="center" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="link-type" @click='$router.push({ name: "trade", query: { key: scope.row.transactioHash } })'>{{ scope.row.transactioHash }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发送账户" align="center" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="link-type" @click='transAddr(scope.row.fromAddress)'>{{ scope.row.fromAddress }}</span>
            </template>
          </el-table-column>
          <el-table-column label="接收账户" align="center" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="link-type" @click='transAddr(scope.row.toAddress)'>{{ scope.row.toAddress }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="主资产编号" align="center" width="150">
            <template slot-scope="scope">
              <span class="">{{ scope.row.transactionOrderId }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="子资产编号" align="center"  min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="">{{ scope.row.subId }}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易订单号" align="center" width="160">
            <template slot-scope="scope">
              <span class="">{{ scope.row.transactionOrderId }}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易时间" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.transactionTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="交易状态" align="center" width="100">
            <template slot-scope="scope">
              <span :class='scope.row.transactionStatus===0?"text-gray":scope.row.transactionStatus===1?"text-green":""'>{{ scope.row.transactionStatus===0?"等待确认":scope.row.transactionStatus===1?"交易成功":"" }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination v-if='device!="mobile"' v-show="total>0" :current-page="Math.floor(listQuery.skipCount/listQuery.maxResultCount)+1" :page-sizes="[10,15,30, 50]" :page-size="listQuery.maxResultCount" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
          <el-pagination
            v-else
            small
            layout="prev, pager, next"
            :total="total"
             @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </template>
      <div v-else class="page-sec">
        <el-row type='flex' justify="center" style='width: 100%;'>
          <el-empty :image-size="100" description="暂未找到您所查询的内容，请重新查询"></el-empty>
        </el-row>
      </div>
      <!-- 表格 -->
      

    </div>
  </div>
</template>

<script>
import { main, table } from '@/api/assets'
import { Mixin } from '@/utils/mixin.js'
import { mapGetters } from 'vuex'

export default {
  name: 'manage',
  mixins: [ Mixin ],
  data() {
    return {
      tableKey: Math.random(),
      info: null,
      list: null,
      total: 0,
      pageLoading: false,
      listLoading: false,
      listQuery: {
        maxResultCount: 10,
        skipCount: 0,
        mainId: this.$route.query.key,
        // 5e5744b5-0af2-4c95-8689-7a8f97c6cb85
      },
    }
  },
  created() {
    if(this.cacheData) {
      this.info = this.cacheData
      this.tableRq()
      this.$store.dispatch('app/cacheData', null)
      return;
    }
    this.fetchList()
  },
  mounted() {
  },
  computed: {
    ...mapGetters([
      'cacheData'
    ]),
  },
  methods: {
    fetchList() {
      this.pageLoading = true
      Promise.all([
        main(this.listQuery.mainId),
        table(this.listQuery)
      ]).then(responses => {
        this.pageLoading = false
        this.info = responses[0].data
        this.tableRqCb(responses[1])
      }).catch(() => {
        this.pageLoading = false
      })
    },
    tableRq() {
      this.listLoading = true
      table(this.listQuery).then(response => {
        this.listLoading = true
        this.tableRqCb(response)
      }).catch(() => {
        this.listLoading = false
      })
    },
    tableRqCb(response) {
      let { data } = response
      if(!data) return;
      this.list = data.items
      this.total = data.totalCount
      this.listLoading = false
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
    // handleFilterClear() {
    //   this.listQuery = {
    //     mainId: "5e5744b5-0af2-4c95-8689-7a8f97c6cb85",
    //   },
    //   this.fetchList()
    // },
  }
}
</script>
